import React, {useEffect, useState} from 'react';
import {useFormState} from 'react-final-form';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Field from 'brandComponents/Form/Subcomponents/Field';

import {IYesOrNoFieldsProps} from './IYesOrNoFields';
import messages from './messages';

import styles from './YesOrNoFields.module.scss';

const YesOrNoFields = ({name, classNames, customTranslation}: IYesOrNoFieldsProps) => {
	const intl = useIntl();
	const formState = useFormState();
	const [error, setError] = useState(formState?.submitErrors?.[name]);

	useEffect(() => {
		if (formState?.values?.[name]) {
			setError(null);
		} else {
			setError(formState?.submitErrors?.[name]);
		}
	}, [formState?.values?.[name], formState?.submitErrors?.[name]]);

	return (
		<>
			<Field
				id={`${name}-yesno-true`}
				name={name}
				type="radio"
				value="true"
				label={customTranslation?.yes ?? intl.formatMessage(messages['yes'])}
				classNamesCntr={cn(classNames, styles['field-yesno'])}
				showSubmitError={false}
			/>
			<Field
				id={`${name}-yesno-false`}
				name={name}
				type="radio"
				value="false"
				label={customTranslation?.no ?? intl.formatMessage(messages['no'])}
				classNamesCntr={cn(classNames, styles['field-yesno'])}
				showSubmitError={false}
			/>
			{error && (
				<span className={cn(styles['field-yesno__error'], 'field-yesno__error')}>
					{error}
				</span>
			)}
		</>
	);
};

export default YesOrNoFields;
